function build() {
  return {
    frame: {
      mode: FrameMode.SINGLE,
      width: 640,
      height: 480,
      lock: {
        wcs: true,
      },
    },
    view: {
      retina: false,
    },
    tileLayer: {
      animationLod: 1,
      lodBias: 0,
      cacheSize: 1000,
      enableMagFilter: true,
    },
    hipsLayer: {
      animationLod: 0,
      lodBias: 0,
    },
  }
}

export const config = {
  build,
}

export enum FrameMode {
  SINGLE = 'SINGLE',
  FRAME = 'FRAME"',
}
